var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4.66667V6.33333C14.6666 8.72667 12.7266 10.6667 10.3333 10.6667H8.66665V14H7.33331V9.33333L7.34598 8.66667C7.51598 6.42933 9.38598 4.66667 11.6666 4.66667H14.6666ZM3.99998 2C6.06131 2 7.81065 3.33667 8.42865 5.19067C7.42865 6.04067 6.76865 7.276 6.67731 8.66667H5.99998C3.42265 8.66667 1.33331 6.57733 1.33331 4V2H3.99998Z",
    fill: "#7E7E8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.aa60b5d809675465e7fb06c6eda35c77.svg";
export { ForwardRef as ReactComponent };